<template>
    <div>
        <div v-if="isSent"><PendingStatus /></div>
        <template v-else>
            <SectionHeader :icon="`icon-upload_2`">
                {{ $t('upload a document photo') | capitalize }}
            </SectionHeader>
            <DocumentUploadForm
                @success="onSuccess"
                @error="onError"
                class="document-upload--in-page"
            />
        </template>
    </div>
</template>

<script>
    import { mapActions } from 'vuex';
    import PendingStatus from '@modules/userProfile/idCardVerification/components/PendingStatus';
    import DocumentUploadForm from '@modules/userProfile/documentUpload/components/DocumentUploadForm';

    export default {
        name: 'AccountContainer',
        data() {
            return {
                isSent: false,
                asyncErrors: {},
            };
        },
        methods: {
            ...mapActions('errors', [
                'showError',
            ]),
            onSuccess() {
                this.isSent = true;
            },
            onError(e) {
                this.showError(e);
            }
        },
        components: {
            PendingStatus,
            DocumentUploadForm
        }
    };
</script>



// WEBPACK FOOTER //
// src/app/modules/userProfile/documentUpload/DocumentUploadContainer.vue